
























import Vue from 'vue'
import axios from 'axios'
import Component from 'vue-class-component'
import { i18n } from '@/plugins/i18n'
import { namespace } from 'vuex-class'
import { User } from '@/models/User'
const AppStore = namespace('AppStore')
const SnackbarStore = namespace('SnackbarStore')

@Component({
  components: {},
})
export default class Login extends Vue {
  @AppStore.Mutation setUser!: (user: User) => void
  @AppStore.Mutation setToken!: (token: string) => void
  @SnackbarStore.Mutation setSnackbarError!: (error: string) => void
  username: string = ''
  password: string = ''
  login() {
    return this.$auth
      .login({
        username: this.username,
        password: this.password,
      })
      .then((r) => {
        let token = r.data.token
        this.setToken(token)
      })
  }
}
